'use strict';

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var options = exports.options = {};
var sizeMap = {
  small: 32,
  medium: 40,
  large: 48,
  xLarge: 64
};

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      UIBox = _ref.UIBox,
      Box = _ref.Box;

  var Header = function (_React$Component) {
    _inherits(Header, _React$Component);

    function Header() {
      _classCallCheck(this, Header);

      return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
    }

    _createClass(Header, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            theme = _props.theme,
            _props$box = _props.box,
            box = _props$box === undefined ? {} : _props$box,
            onClick = _props.onClick,
            className = _props.className;
        return _react2['default'].createElement('div', {
          className: this.headerWrapperClass
        }, _react2['default'].createElement(Box, {
          theme: theme,
          className: className,
          bgColor: box.bgColor,
          top: 'medium',
          left: 'medium',
          bottom: 'medium',
          right: 'medium'
        }, _react2['default'].createElement('div', {
          className: this.headerLogoWrapperClass,
          onClick: onClick
        }, _react2['default'].createElement('img', {
          className: this.headerLogoClass,
          src: this.optimizedImageSrc,
          alt: 'header logo'
        }))));
      }
    }, {
      key: 'devicePixelRatio',
      get: function get() {
        return 2;
      }
    }, {
      key: 'headerLogoWrapperClass',
      get: function get() {
        var _cn;

        var _props2 = this.props,
            theme = _props2.theme,
            alignment = _props2.alignment;
        return (0, _classnames2['default'])(theme.headerLogoWrapper, (_cn = {}, _defineProperty(_cn, theme.logoLeft, alignment === 'left'), _defineProperty(_cn, theme.logoCenter, alignment === 'center'), _defineProperty(_cn, theme.logoRight, alignment === 'right'), _cn));
      }
    }, {
      key: 'headerLogoClass',
      get: function get() {
        var _cn2;

        var _props3 = this.props,
            theme = _props3.theme,
            size = _props3.size;
        return (0, _classnames2['default'])(theme.headerLogo, (_cn2 = {}, _defineProperty(_cn2, theme.logoSmall, size === 'small'), _defineProperty(_cn2, theme.logoMedium, size === 'medium'), _defineProperty(_cn2, theme.logoLarge, size === 'large'), _defineProperty(_cn2, theme.logoXLarge, size === 'xLarge'), _cn2));
      }
    }, {
      key: 'optimizedImageSrc',
      get: function get() {
        var _props4 = this.props,
            src = _props4.src,
            size = _props4.size;
        var newImageUrl = src.split('?')[0];
        return newImageUrl + '?h=' + sizeMap[size] + '&dpr=' + this.devicePixelRatio + '&q=75&auto=format,compress';
      }
    }, {
      key: 'headerWrapperClass',
      get: function get() {
        var _props5 = this.props,
            theme = _props5.theme,
            preventDesktopBehaviour = _props5.preventDesktopBehaviour;
        return (0, _classnames2['default'])(theme.headerWrapper, _defineProperty({}, theme.preventDesktop, preventDesktopBehaviour));
      }
    }]);

    return Header;
  }(_react2['default'].Component);

  var options = {
    alignment: ['left', 'right', 'center'],
    size: ['small', 'medium', 'large', 'xLarge']
  };
  Header.displayName = identifier;
  Header.propTypes = {
    src: _propTypes2['default'].string,
    box: _propTypes2['default'].shape({
      bgColor: Box.propTypes.bgColor,
      horizontal: Box.propTypes.horizontal,
      vertical: Box.propTypes.vertical
    }),
    alignment: _propTypes2['default'].oneOf(options.alignment),
    size: _propTypes2['default'].oneOf(options.size),
    onClick: _propTypes2['default'].func,
    theme: _propTypes2['default'].shape(_extends({}, UIBox.themeShape, {
      logoLeft: _propTypes2['default'].string,
      logoCenter: _propTypes2['default'].string,
      logoRight: _propTypes2['default'].string,
      logoSmall: _propTypes2['default'].string,
      logoMedium: _propTypes2['default'].string,
      logoLarge: _propTypes2['default'].string,
      logoXLarge: _propTypes2['default'].string,
      headerWrapper: _propTypes2['default'].string,
      preventDesktop: _propTypes2['default'].string
    })),
    className: _propTypes2['default'].string,
    preventDesktopBehaviour: _propTypes2['default'].bool
  };
  Header.defaultProps = {
    preventDesktopBehaviour: false,
    alignment: 'left',
    size: 'small'
  };
  return Header;
};

exports['default'] = factory;